export default "__VITE_ASSET__CeE3tyI6__"